module.exports = __webpack_public_path__ + "img/TekkiTV.91445b80.jpg";